// Stylesheets
import './assets/scss/site.scss';

import {fixSvgIntrinsicSizing} from './assets/modules/_fixSvgIntrinsicSizing';
import {hover} from './assets/modules/hover';
import {focus} from './assets/modules/focus';
import {lazyload} from './assets/modules/lazyload';
import {trigger} from './assets/modules/trigger';
import {popupYouTube} from './assets/modules/popupYouTube';
import {ytInit} from './assets/modules/ytInit';
import {scrollSnap} from './assets/modules/scrollSnap';
import {scrollNav} from './assets/modules/scrollNav';
import {scrollLogo} from './assets/modules/scrollLogo';
import {carousel} from './assets/modules/carousel';
import {pageTop} from './assets/modules/pageTop';
import {marquee} from './assets/modules/marquee';
import {initPhotoSwipeFromDOM} from './assets/modules/photoswipe-init';

const init = () => {
  trigger();
  fixSvgIntrinsicSizing();
  hover();
  focus();
  lazyload();
  popupYouTube();
  pageTop();
  ytInit();
  scrollNav();
  scrollSnap();
  scrollLogo();
  carousel();
  marquee();
  initPhotoSwipeFromDOM('.js-pswp-container');
}

init();